'use client'

import { type ReactNode, Suspense } from 'react'
import { ErrorBoundary, type ErrorBoundaryPropsWithFallback } from 'react-error-boundary'

interface SuspenseErrorBoundaryProps extends Omit<
  ErrorBoundaryPropsWithFallback,
  'fallback' | 'children'
> {
  children: ReactNode
  fallback: ReactNode
  errorFallback?: ReactNode
}

export function SuspenseErrorBoundary({
  children,
  fallback,
  errorFallback,
  onError,
  ...errorBoundaryProps
}: SuspenseErrorBoundaryProps) {
  return (
    <ErrorBoundary fallback={errorFallback ?? fallback} onError={onError} {...errorBoundaryProps}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </ErrorBoundary>
  )
}
